/** Stable empty list for nav props when Home is inactive. */
export const NO_THREADS = []
